import * as React from 'react';
import styles from './index.less';
import { DatePicker, InputNumber } from 'antd';
import dayjs from 'dayjs';
import customParseFormat from 'dayjs/plugin/customParseFormat';

dayjs.extend(customParseFormat);
import { FI18n } from '@freelog/tools-lib';
import FSelect2 from '@/components/FSelect2';

export interface DisplayItem {
  id: string; // 唯一标识，用于寻找在策略模板和翻译模版中替换填充的位置
  type:
  | 'text' // 文本
  | 'number' // 数字
  | 'datetime' // 日期时间
  | 'select'; // 选择;
  text?: {
    value: string; // 展示的文字
  };
  number?: {
    value: number; // 填充的数字
    min?: number; // 最小值
    max?: number; // 最大值
    precision?: number; // 小数位数
  };
  datetime?: {
    value: string; // 填充的日期时间，格式: YYYY-MM-DD HH:mm
    minDatetime?: string; // 最小日期（包含），同样会限制面板的切换范围，格式：YYYY-MM-DD HH:mm
    maxDatetime?: string; // 最大日期（包含），同样会限制面板的切换范围，格式：YYYY-MM-DD HH:mm
  };
  select?: {
    value: string; // 填充的选项
    options: {
      label: string; // 展示的文字
      value: string; // 填充的值
    }[];
  };
}

interface EditorProps {
  displayItems: DisplayItem[];

  onChange_DisplayItems?(displayItems: DisplayItem[]): void;
}

function Editor({ displayItems, onChange_DisplayItems }: EditorProps) {
  // console.log(displayItems, 'displayItems sedfi8ojkew;lkfjslkdj')
  return (
    <div className={styles.editor}>
      {displayItems.map((item) => {
        return (
          <React.Fragment key={item.id}>
            {/* <div>{item.type}</div> */}
            {item.type === 'text' && (
              <>
                {item.text?.value.split('\n').map((textLine, index) => {
                  if (index === 0) {
                    return (
                      <React.Fragment key={index}>
                        <span>{textLine}</span>
                      </React.Fragment>
                    );
                  }
                  return (
                    <React.Fragment key={index}>
                      <div className={styles.br} />
                      <span>{textLine}</span>
                    </React.Fragment>
                  );
                })}
              </>
            )}
            {item.type === 'number' && (
              <div className={styles.numberContainer}>
                <InputNumber
                  min={item.number?.min}
                  max={item.number?.max}
                  value={item.number?.value}
                  className={styles.numberInput}
                  precision={item.number?.precision}
                  onChange={(value) => {
                    const newDisplayItems = displayItems.map((i) => {
                      if (i.id === item.id) {
                        return {
                          ...item,
                          number: { ...item.number, value: value },
                        };
                      }
                      return i;
                    });
                    onChange_DisplayItems?.(newDisplayItems as DisplayItem[]);
                  }}
                />
              </div>
            )}
            {item.type === 'datetime' && (
              <div className={styles.datetimeContainer}>
                <DatePicker
                  className={styles.datetimeInput}
                  // placeholder={'选择日期时间'}
                          placeholder={FI18n.i18nNext.t('hint_time_datetime')}
                  // style={{ width: 160 }}
                  showTime={{ format: 'HH:mm' }}
                  format='YYYY-MM-DD HH:mm'
                  // disabledDate={(currentDate) => {
                  //   return currentDate.isBefore(moment());
                  // }}
                  allowClear={false}
                  value={
                    item.datetime?.value ? dayjs(item.datetime?.value, 'YYYY-MM-DD HH:mm') : null
                  }
                  // disabledTime={disabledTime}
                  onChange={(value: any, dateString: any) => {
                    // const mo: Moment | null =
                    //   (value?.valueOf() || -1) < moment().valueOf() ? moment() : value;
                    // onChangeCombinationEvent(
                    //   {
                    //     absoluteTime_DateTime: mo,
                    //   },
                    //   cd.randomID,
                    //   et.randomID,
                    // );
                    const newDisplayItems = displayItems.map((i) => {
                      if (i.id === item.id) {
                        return {
                          ...item,
                          datetime: { ...item.datetime, value: dateString },
                        };
                      }
                      return i;
                    });
                    // console.log(newDisplayItems, 'newDisplayItems3erwfsdafds w23refsdfqWerfasd');
                    onChange_DisplayItems?.(newDisplayItems as DisplayItem[]);
                  }}
                />
              </div>
            )}
            {item.type === 'select' && (
              <div className={styles.selectContainer}>
                <FSelect2
                  style={{ width: 90 }}
                  value={item.select?.value}
                  options={item.select?.options}
                  onChange={(value) => {
                    // onChange_DisplayItems?.([...displayItems, {
                    //   id: item.id,
                    //   type: 'select',
                    //   value: value,
                    // }]);
                    const newDisplayItems = displayItems.map((i) => {
                      if (i.id === item.id) {
                        return {
                          ...item,
                          select: { ...item.select, value: value },
                        };
                      }
                      return i;
                    });
                    // console.log(newDisplayItems, 'newDisplayItems3480听围绕数据发D类开讲啦开始的');
                    onChange_DisplayItems?.(newDisplayItems as DisplayItem[]);
                  }}
                />
              </div>
            )}
          </React.Fragment>
        );
      })}
    </div>
  );
}

export default Editor;
